import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const stats = [
    { value: '10+', label: 'Years of Experience' },
    { value: '200+', label: 'Destinations' },
    { value: '10,000+', label: 'Happy Travelers' },
    { value: '98%', label: 'Satisfaction Rate' },
  ];

  const values = [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      title: 'Trust & Safety',
      description: 'Your safety and security are our top priorities. We work with vetted partners and maintain the highest standards.',
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
        </svg>
      ),
      title: 'Excellence',
      description: 'We strive for excellence in every detail, from planning to execution, ensuring unforgettable experiences.',
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      ),
      title: 'Sustainability',
      description: 'We promote responsible travel that respects local communities and protects our planet for future generations.',
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      title: 'Community',
      description: 'We build connections between travelers and local communities, creating meaningful cultural exchanges.',
    },
  ];

  const team = [
    {
      name: 'E. Whittaker',
      role: 'Founder & CEO',
      image: '/res/team/Whittaker.jpeg',
      description: 'Passionate traveler with 20+ years of experience in the tourism industry.',
    },
    {
      name: 'James Short',
      role: 'Co-Founder and Brand Partner',
      image: '/res/team/James_Short.jpeg',
      description: 'Ensures seamless execution of every tour with meticulous attention to detail.',
    }
  ];

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <div
          style={{ backgroundImage: "url('/res/kit-formerly-convertkit-htQznS-Rx7w-unsplash.jpg')" }}
          className="bg-cover bg-[position:top_40%] text-white py-20 sm:py-28 relative"
        >
          <div className="absolute inset-0 bg-gradient-to-r to-gray-900 from-orange-500 opacity-20"></div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6 inline-block">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500">
                About Compass Connections Agency
              </span>
            </h1>
            <p className="text-xl text-white max-w-3xl mx-auto">
              We&apos;re passionate about creating unforgettable travel experiences that inspire, educate, and connect people across the globe.
            </p>
          </div>
        </div>

        {/* Stats Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {stats.map((stat, index) => (
              <div key={index} className="bg-white/55 backdrop-blur-lg rounded-xl shadow-lg shadow-gray-300 p-6 text-center relative overflow-hidden group">
                <div className="absolute bottom-0 left-0 h-1 bg-gradient-to-r to-blue-600 from-blue-400 w-0 group-hover:w-full transition-all duration-500 ease-out"></div>
                <div className="text-3xl sm:text-4xl font-bold text-blue-600 mb-2">
                  {stat.value}
                </div>
                <div className="text-sm sm:text-base text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Our Story */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
                Our Story
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2 mb-6">
                Turning Travel Dreams Into Reality
              </h2>
              <div className="prose prose-lg text-gray-700 space-y-4">
                <p>
                  At Compass Connection Agency, we believe every journey should be as unique and unforgettable as the traveler taking it. We go beyond traditional travel planning, crafting seamless, personalized experiences designed to inspire, indulge, and connect you to the world in meaningful ways.
                </p>
                <p>
                  Our philosophy is simple: travel should enrich your life, not just fill your itinerary. Whether it’s a private island escape, a romantic European getaway, a cultural immersion in Africa, or a family adventure through hidden gems, we tailor every detail to reflect your passions, preferences, and pace.
                </p>
                <p>
                  With our global network of trusted partners, exclusive access to luxury accommodations, and insider experiences few ever see, we ensure each trip is effortless and extraordinary. Yet behind the sophistication lies a personal touch — genuine care, thoughtful guidance, and a deep commitment to your satisfaction from start to finish.
                </p>
                <p>
                  More than travel planners, we are your dedicated advocates, curators, and storytellers. We listen to your dreams, understand your desires, and transform them into journeys that leave lasting impressions. Because at Compass Connection Agency, we don’t just create trips — we create lifelong memories.
                </p>
              </div>
            </div>
            <div className="relative h-96 lg:h-full min-h-[400px] rounded-xl overflow-hidden shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500 flex items-center justify-center">
                <svg
                  className="w-32 h-32 text-white opacity-20"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Our Values */}
        <div className="bg-black py-40" id='why-choose-us'>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
                Our Values
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-blue-100 mt-2 mb-4">
                What We Stand For
              </h2>
              <p className="text-lg text-blue-600 max-w-2xl mx-auto">
                Our core values guide every decision we make and every experience we create
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4 text-blue-300">
                    {value.icon}
                  </div>
                  <h3 className="text-xl font-bold text-blue-700 mb-2">{value.title}</h3>
                  <p className="text-blue-200">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Team Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center mb-12">
            <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
              Our Team
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2 mb-4">
              Meet the People Behind Compass Connection Agency
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Passionate professionals dedicated to making your travel dreams come true
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden group w-sm mx-auto pt-4">
                <div className="relative w-64 h-64 rounded-t-full rounded-b-full mx-auto overflow-hidden">
                  {/* <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div> */}
                  <img
                    src={member.image}
                    alt={`Photo of ${member.name}`}
                    className="w-full h-full object-cover group-hover:opacity-65 transition-all duration-100"
                  />
                </div>
                <div className="p-6 text-center rounded-lg shadow-2xl z-10 relative bg-gray-50 group-hover:bg-gradient-to-b group-hover:to-gray-300 transition-all duration-300">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-blue-600 font-semibold mb-3">{member.role}</p>
                  <p className="text-gray-600">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6">
              Ready to Start Your Adventure?
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Join thousands of travelers who have discovered the world with CompassGo
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to="/tours"
                className="px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors shadow-lg"
              >
                Explore Tours
              </Link>
              <Link
                to="/contact"
                className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-600 transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}